import React, {useState} from 'react'
import ConfirmDeleteDialog from "../ConfirmDeleteDialog";
import Menu from "@material-ui/core/Menu";
import FormAccessDialog from "./FormAccessDialog";
import * as Icon from "react-feather";

function AccessActionMenu({user, handleDelete, Project_ID}) {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <button className="btn btn-transparent-dark btn-sm" onClick={handleClick}>
                <Icon.MoreVertical size={18} />
            </button>
            <Menu
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                <FormAccessDialog
                    user={user}
                    handleMenuClose={handleClose}
                    Project_ID={Project_ID}
                />
                <ConfirmDeleteDialog
                    User_ID={user.User_ID}
                    Project_ID={Project_ID}
                    Type="User"
                    Name={user.Name}
                    handleDelete={handleDelete}
                    handleMenuClose={handleClose}
                />
            </Menu>
        </>

    )
}
export default AccessActionMenu